import React, {useState} from 'react';
import {arrowdown, arrowup, arrowIcon, barcode, planetIcon, compassIcon, dotIcon, Prathu_CV} from '../assets';
import './Contact.css';
import { Galaxy } from '../components';

const Contact = () => {
  const [copied, setCopied] = useState(false);
  const email = "agrawalprathu@gmail.com";

  const handleCopy = () => {
    navigator.clipboard.writeText(email);
    setCopied(true);
    setTimeout(() => setCopied(false), 1200);
  };

  return (
    <section id="contact" className="contact">
      <div style={{ 
        position: 'absolute', 
        top: 'auto', 
        left: 0, 
        width: '100%', 
        height: '120%', 
        zIndex: -1
      }}>
        <Galaxy 
          mouseRepulsion={true}
          mouseInteraction={true}
          density={1}
          glowIntensity={0.5}
        />
      </div>
      <div className="titletext">
        <div className='l2'>LET'S BUILD</div>
        <div className='l2bd'>TOGETHER</div>
      </div>
      {/* socials */}
      <img src={arrowdown} className="arrowd" alt="pointer"></img>
        <div className='email' onClick={handleCopy} style={{cursor: "pointer"}}>
          <div className="email-address">{email}</div>
          <div className="email-copy">
            {copied ? "Copied!" : "Click-To Copy"}
          </div>
        </div>
        <span className="socials">
          <div className="socials-label">SOCIALS</div>
          <div className='socials-links'>
            <a href="https://github.com/SeaM05" target="_blank" rel="noopener noreferrer" className="social-link">
              GITHUB <img src={arrowup } className="arrowu" alt="pointer"></img>
            </a>
            <a href="https://www.linkedin.com/in/prathu-/" target="_blank" rel="noopener noreferrer" className="social-link">
              LINKEDIN<img src={arrowup } className="arrowu" alt="pointer"></img>
            </a>
            <a href={Prathu_CV} download="Prathu_CV" target="_blank" className="social-link">
              CV<img src={arrowup } className="arrowu" alt="pointer"></img>
            </a>
          </div>
        </span>

     
      <button className='button3' onClick={() =>  window.location.href = `mailto:${email}`}>
        <img src={arrowIcon} alt="Icon" className="arrowl" />
        &nbsp; LET'S<br></br>&nbsp; COLLABORATE
      </button>

      <div className="barcode-container">
        <img src={barcode} alt="Barcode" className="barcode" />
        <div className="barcode-icons">
          <img src={compassIcon} alt="Compass Icon" className="compass-icon" />
          <img src={planetIcon} alt="Planet Icon" className="planet-icon" />
          <img src={dotIcon} alt="Dot Icon" className="dot-icon" />
        </div>
        <div className="barcode-text">
          <span className="barcode-year">©{new Date().getFullYear()}-</span>
          <span className="prathu-font">PRATHU</span>
        </div>    
      </div>
      <div className="divider-end"></div>
    </section>
  );
};

export default Contact;
